export default __webpack_public_path__ + "static/media/nuevas-localidades.9f765789.jpeg";